import { useMemo, useState } from "react";

import { getScheduledEvents } from "../api/api";
import useSignal from "./useSignal";
import useApiEffect from "./useApiEffect";
import { ScheduledEventModel } from "../typings/models";

const useScheduledEvents = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [items, setItems] = useState<ScheduledEventModel[]>([]);
  const signal = useSignal();

  const mutate = async () => {
    setIsLoading(true);
    const response = await getScheduledEvents({ signal });
    if (signal.aborted) return;
    setIsLoading(false);
    if (response.status !== "success") {
      setItems([]);
      return;
    }
    setItems(response.data);
  }

  useApiEffect(async () => {
    await mutate();
  }, []);

  return { items, isLoading, mutate };
};

export default useScheduledEvents;
